import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { DumbLiaison } from '../../../member-admin/membership-management/DTOs/dumb-liaison';
import { DumbPublicMember } from '../DTOs/dumb-public-member';
import { DumbPublicMemberLocation } from '../DTOs/dumb-public-member-location';
import { MemberInformationService } from '../member-information.service';
import { } from 'googlemaps';
import { IntroduceYourselfModalComponent } from '../modals/introduce-yourself-modal.component';
import { AuthService } from '../../../core/auth.service';

@Component({
  selector: 'app-member-profile',
  templateUrl: './member-profile.component.html',
  providers: [UIBlockingService],
  encapsulation: ViewEncapsulation.None
})
export class MemberProfileComponent {
  constructor(private memberInformationService: MemberInformationService
    , private blockUI: UIBlockingService
    , private route: ActivatedRoute
    , private router: Router
    , private modalService: NgbModal
    , private authService: AuthService
    , private notificationService: ToastNotificationService) { }

  @ViewChild('map') mapElement: any;
  map: google.maps.Map;
  markers: google.maps.Marker[] = [];
  memberId: string | null = '';
  member: DumbPublicMember = new DumbPublicMember();
  liaison: DumbLiaison = new DumbLiaison();
  locations: DumbPublicMemberLocation[] = [];
  canViewMemberContent:boolean = false;
  isMyCompany: boolean = false;
    hasLetterOfIntroPerk: boolean = false;

  ngOnInit() {
    this.memberId = this.route.snapshot.paramMap.get("memberId");
    this.getMemberDetails();
      this.canViewMemberContent = this.authService.canAccessMemberOnlyContent();
      this.hasLetterOfIntroPerk = this.authService.hasLetterOfIntroPerk();
  }

  ngAfterViewInit(): void {
    const mapProperties = {
      center: new google.maps.LatLng(39.7691, -86.1580),
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
  }

  getMemberDetailsObservable(): Observable<DumbPublicMember> {
    return this.memberInformationService
      .getMemberDetails(this.memberId);
  }
  zoomToIconAddress(loc: DumbPublicMemberLocation) {
    this.map.setCenter(new google.maps.LatLng(loc.lat, loc.long))
  }
  getMemberDetails() {
    this.blockUI.start();

    this.getMemberDetailsObservable()
      .subscribe(
        {
          next: (data) => {
            this.member = data;
            this.liaison = data.liaison;
            this.locations = data.locations;
            this.addPinsToMap(this.locations);
            this.isMyCompany = localStorage.getItem('contactId') == data.liaison.contactId;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  introduceYourself() {
    const modalRef = this.modalService.open(IntroduceYourselfModalComponent, { size: 'lg' });
    modalRef.componentInstance.memberName = this.member.memberName;
    modalRef.componentInstance.memberId = this.member.companyId;
    modalRef.result.then(response => {
      this.member.canRequestIntro = false;
    })
      .catch(err => {

      }).finally();
  }

  addPinsToMap(locs: DumbPublicMemberLocation[]) {
    locs.forEach(loc => {
      var newMark = new google.maps.Marker({
        position: new google.maps.LatLng(loc.lat, loc.long),
        map: this.map,
        title: loc.locationName
      })
      this.markers.push(newMark);
    });
  }
}
